import { AllCountryCode, STATES } from '@afterpaytouch/core'
import { PaymentType } from '@afterpay/types'

export type BlackListedStatesRecord = Partial<Record<AllCountryCode, string[]>>

interface BlacklistedStates {
  [PaymentType.PCL]: BlackListedStatesRecord
  [PaymentType.PBI]: BlackListedStatesRecord
}

export const BLACKLISTED_STATES: BlacklistedStates = {
  [PaymentType.PCL]: {
    US: [STATES.US.label.WV, STATES.US.label.NV, STATES.US.label.HI, STATES.US.label.NM],
  },
  [PaymentType.PBI]: {
    US: [STATES.US.label.NM],
  },
}
